module.exports = __webpack_public_path__ + "assets/img/level3.122c97a7.png";